<form [formGroup]="chipForm">
   <div class="flex flex-row gap-2 mb-2">
      <p-chips
         #chips
         [inputId]="filter.filter.id"
         formControlName="chips"
         [allowDuplicate]="false"
         class="w-80 chip-max-width block md:w-80"
         styleClass="w-80 chip-max-width block md:w-80"
         separator=","
         (keyup)="onChipInputKeyup(chips)"
         [placeholder]="'Entra ' + chipFilter?.label"
      ></p-chips>

      <button
         type="button"
         pButton
         icon="pi pi-plus"
         label="Añadir"
         class="chip-button"
         severity="secondary"
         (click)="addChipFromInput(chips)"
      ></button>

      <p-chip *ngIf="chipCount > 0" [label]="chipCount.toString()" class="flex align-items-center"></p-chip>
   </div>
</form>
